import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ReactComponent as DoneIcon } from '../assets/icons/svg/end/done.svg';

const LectureEndPage = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [isDarkMode] = useState(() => localStorage.getItem('lecturePageDarkMode') === 'true');

    return (
        <div className={`w-full min-h-[100dvh] flex flex-col items-center overflow-x-hidden ${isDarkMode ? 'bg-[#0D0D0D]' : 'bg-white'}`}>
            <div className="w-full max-w-md md:max-w-lg flex flex-col items-center px-6 mt-[clamp(56px,10vh,120px)]">
                {/* 아이콘 */}
                <DoneIcon className="w-[100px] h-[100px] md:w-[120px] md:h-[120px]" />

                {/* 텍스트 */}
                <div className={`mt-4 md:mt-6 text-center text-[20px] md:text-[24px] font-semibold leading-[140%] ${isDarkMode ? 'text-white' : 'text-[#161819]'}`}>
                    <p>{t("end.title")}</p>
                    <p>{t("end.message")}</p>
                </div>

                {/* 버튼 */}
                <button
                    onClick={() => navigate('/')}
                    className="lsp-primary mt-8 md:mt-10 w-full h-12 md:h-14 rounded-lg flex justify-center items-center gap-1 pl-5 pr-[18px]"
                >
                    <span className="text-white text-[15px] md:text-[17px] font-medium leading-[150%] tracking-[-0.005em]">
                        {t("end.button")}
                    </span>
                </button>
            </div>
        </div>
    );
};

export default LectureEndPage;
